import { Template } from '../../../api/templateApi';

import { sortByLabel } from '../../../util/SelectionOptionUtils';

export const getTemplatesOptions = (templates: Template[], value = 'id') => {
  return templates
    .map((template: Template) => ({
      label: template.name + ' (' + template.prefix + ')',
      value: template[value as keyof Template]?.toString(),
      parent: template.parent ?? null,
      properties: {
        effective_on_approval: template.document_effective_on_approval,
        training_required: template.training_required,
        review_period: template.document_review_period,
        training_available: template.training_available,
        file_download_user_groups: template.file_download_user_groups
          ? template.file_download_user_groups
          : [],
        template_id: template.id,
        id: template.id,
      },
    }))
    .sort(sortByLabel);
};
